import { __rest } from 'tslib';
import { FormLabel } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

const PeekFormLabel = styled((_a) => {
    var props = __rest(_a, ["bold"]);
    return (React.createElement(FormLabel, Object.assign({}, props)));
})(({ theme, bold = false, size = "medium" }) => (Object.assign(Object.assign(Object.assign(Object.assign({}, theme.typography.h4), { color: theme.palette.text.primary, marginBottom: theme.spacing(0.7) }), (bold && {
    fontWeight: theme.typography.fontWeightMedium,
})), (size != "medium" && Object.assign({}, theme.typography.body1)))));

export { PeekFormLabel, PeekFormLabel as default };
